import { BaseRestApiEndpoint } from "utils/api";
import { IConversation, IMessage, IConversationParticipant } from "utils/user";

type TOutput = IConversation;

export default abstract class ConversationResponseBasedApiEndpoint<
  Input,
> extends BaseRestApiEndpoint<Input, TOutput> {
  mapResponseData(_: number, data: any): TOutput {
    return {
      id: data.attributes.conversation_id,
      messages: data.messages.map(
        (x: any): IMessage => ({
          id: x.id,
          userId: x.user_id,
          message: x.msg,
          publishedAt: x.pub_date,
        }),
      ),
      participants: data.users.map(
        (x: any): IConversationParticipant => ({
          firstName: x.first_name,
          lastName: x.last_name,
          phone: x.phone,
          type: x.type,
          id: x.id,
          photoPath: x.photo_path,
          isPrivateLandlord: x.is_private_landlord,
        }),
      ),
    };
  }
}
